import React, { useState } from 'react';
import LinesEllipsis from 'react-lines-ellipsis';
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC';
const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis);

function JobCategoryCollapsibleText({
  title,
  content
}: {
  title: string;
  content: string;
}): JSX.Element {
  const [collapse, setCollapse] = useState(true);

  const seeAllEllipsis = (
    <>
      ...&nbsp;
      <span className="btn-link cursor-pointer" onClick={() => setCollapse((state) => !state)}>
        See all
      </span>
    </>
  );

  return (
    <>
      <div className="font-semibold text-base mb-2 tracking-wide mt-4">{title}</div>
      {collapse ? (
        <ResponsiveEllipsis
          className="w-[624px] text-sm text-justify tracking-wide text-gray-700"
          text={content}
          maxLine="4"
          ellipsis={seeAllEllipsis as unknown as string}
          trimRight
          basedOn="letters"
        />
      ) : (
        <div className="text-sm text-justify tracking-wide text-gray-700">
          {content}&nbsp;
          <span className="btn-link cursor-pointer" onClick={() => setCollapse((state) => !state)}>
            See less
          </span>
        </div>
      )}
    </>
  );
}

export default JobCategoryCollapsibleText;
